export const getReceiptFilter = state => state.receiptReport.filter
